import * as actionTypes from './actionTypes'

// import { saveFileFromResponse } from '../../helpers/utils'
import { enqueueSnackbar } from './alert'
import dashboardAxios from '../../axios/dashboardBranchPerformance'

export const dashboardBranchPerformance = recordData => {
  return dispatch => {
    dispatch(dashboardBranchPerformanceStart())

    dashboardAxios
      .get('/province', { params: recordData })
      .then(response => {
        if (response.status === 200) {
          dispatch(dashboardBranchPerformanceSuccess(response.data))
        }
      })
      .catch(error => {
        dispatch(dashboardBranchPerformanceFailed(error))
      })
      .catch(error => {
        switch (error?.response?.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Error',
                options: {
                  variant: 'error',
                  data: error?.response?.data?.data ?? []
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error?.response?.data?.message ?? '',
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(dashboardBranchPerformanceFailed())
      })
  }
}

export const dashboardBranchPerformanceStart = () => {
  return {
    type: actionTypes.DASHBOARD_BRANCH_PERFORMANCE_START
  }
}

export const dashboardBranchPerformanceSuccess = data => {
  return {
    type: actionTypes.DASHBOARD_BRANCH_PERFORMANCE_SUCCESS,
    data
  }
}

export const dashboardBranchPerformanceFailed = () => {
  return {
    type: actionTypes.DASHBOARD_BRANCH_PERFORMANCE_FAILED
  }
}

export const clearDashboardBranchPerformance = () => {
  return {
    type: actionTypes.CLEAR_DASHBOARD_BRANCH_PERFORMANCE
  }
}

export const dashboardBranchPerformanceDetail = recordData => {
  return dispatch => {
    dispatch(dashboardBranchPerformanceDetailStart())

    dashboardAxios
      .get('/all', { params: recordData })
      .then(response => {
        if (response.status === 200) {
          dispatch(dashboardBranchPerformanceDetailSuccess(response.data))
        }
      })
      .catch(error => {
        dispatch(dashboardBranchPerformanceDetailFailed(error))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Error',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: error.response.data.message,
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(dashboardBranchPerformanceDetailFailed())
      })
  }
}

export const dashboardBranchPerformanceDetailStart = () => {
  return {
    type: actionTypes.DASHBOARD_BRANCH_PERFORMANCE_DETAIL_START
  }
}

export const dashboardBranchPerformanceDetailSuccess = data => {
  return {
    type: actionTypes.DASHBOARD_BRANCH_PERFORMANCE_DETAIL_SUCCESS,
    data
  }
}

export const dashboardBranchPerformanceDetailFailed = () => {
  return {
    type: actionTypes.DASHBOARD_BRANCH_PERFORMANCE_DETAIL_FAILED
  }
}
